const initialState = {
    isReadingSchedule: false,
    days: [],
    timezones: null,
    isUpdatingSchedule: false
};

export default initialState;
